module.exports = __webpack_public_path__ + "img/backgroundImg3.f41eb5aa.png";